"use client";

import { useQuery } from "@tanstack/react-query";

import Loading from "@/app/loading";
import GetSurveyDataTable from "@/components/health-and-retirement-studies/get-data/get-survey-data-table";
import FetchError from "@/components/ui/fetch-error";
import { GetSurveyDataProps } from "@/types";

import api from "@/lib/api";

export default function GetSurveyData() {
  const { data, error, isPending } = useQuery({
    queryKey: ["survey-get-covid-data"],
    queryFn: () =>
      api.get<GetSurveyDataProps[]>("/srv/get-data/?site_name=covid"),
  });

  if (isPending) {
    return <Loading />;
  }

  if (error) return <FetchError />;

  return <GetSurveyDataTable data={data} />;
}
